const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const API_TIMEOUT = 60000;
const PAGE_SIZE = 30;
const MAP_KEY = process.env.REACT_APP_MAP_KEY!;

export {
  API_ENDPOINT,
  API_TIMEOUT,
  PAGE_SIZE,
  MAP_KEY,
};
